import {processTranslation} from '../components/utils/commonUtil';
import { isUsSite, isAuSite, isNzSite } from './validate';

const setIneligibilityInfoMessages = (infoMessages, ineligibilityStatus, brandName, siteName) => {
    switch (ineligibilityStatus) {
        case 'INVALID_PROPERTY_COUNT' :
            infoMessages.header_1 = 'ipmob.ineligible_page.heading_3';
            infoMessages.contents = [
                'ipmob.ineligible_page.content_4',
                'ipmob.ineligible_page.content_1'
            ];
            break;
        case 'EXISTING_IPM_USER' :
            infoMessages.contents = ['ipmob.ineligible_page.message_11'];
            break;
        case 'INVALID_BUSINESS_TYPE' :
            infoMessages.contents = [
                processTranslation('ipmob.ineligible_page.message_2', [brandName]),
                'ipmob.ineligible_page.content_6'
            ];
            break;
        case 'INVALID_VAT_AND_INVALID_BUSINESS_TYPE' :
            infoMessages.contents = [
                processTranslation('ipmob.ineligible_page.message_3', [brandName]),
                'ipmob.ineligible_page.content_6'
            ];
            break;
        case 'INVALID_VAT_AND_EXCLUDE_TAX_IDENTIFIER':
        case 'INVALID_VAT' :
            infoMessages.contents = ['ipmob.ineligible_page.message_4'];
            break;
        case 'INVALID_VAT_AND_INVALID_REG_NO' :
            infoMessages.contents = ['ipmob.ineligible_page.message_23'];
            break;
        case 'INVALID_VAT_NUMBER' :
            infoMessages.contents = ['ipmob.ineligible_page.message_6'];
            break;
        case 'INELIGIBLE_PPM' :
        case 'SERVICE_FEE_VIOLATOR' :
        case 'NFMP_VIOLATOR' :
            infoMessages.contents = ['ipmob.ineligible_page.message_12'];
            break;
        case 'MULTIPLE_ACCOUNT' :
            infoMessages.contents = [
                'ipmob.ineligible_page.message_8',
                'ipmob.ineligible_page.content_6'
            ];
            if (isUsSite(siteName) || isAuSite(siteName) || isNzSite(siteName) ) {
                const removeEmailUsKey = ['ipmob.ineligible_page.content_6'];
                infoMessages.contents = infoMessages.contents.filter(item => !removeEmailUsKey.includes(item));
            }
            break;
        case 'NO_SOFTWARE_INELIGIBILTY' :
            infoMessages.contents = ['ipmob.ineligible_page.message_13'];
            break;
        case 'DUPLICATE_PROJECT':
            infoMessages.contents = ['ipmob.ineligible_page.message_14'];
            break;
        case 'INVALID_PRIVATE_OWNER':
            infoMessages.header_1 = 'ipmob.ineligible_page.heading_6';
            infoMessages.contents = [
                'ipmob.ineligible_page.message_24',
                'ipmob.ineligible_page.message_25'
            ];
            break;
        case 'UNSUPPORTED_PAYOUT_COUNTRY':
            infoMessages.header_1 = 'ipmob.payout_details.unsupported_country.heading';
            infoMessages.contents = [
                'ipmob.payout_details.unsupported_country.content_1',
                'ipmob.payout_details.unsupported_country.content_2'
            ];
            break;
        default :
            infoMessages.header_2 = '';
            infoMessages.subHeading = '';
            infoMessages.contents = [
                'ipmob.ineligible_page.message_12'
            ];
    }
};

const infoMessageMapper = (messageKey, ineligibilityStatus, brandName, siteName) => {
    const infoMessages = {
        header_1: 'ipmob.information_pg.heading_1',
        header_2: 'ipmob.information_pg.heading_2',
        subHeading: 'ipmob.information_pg.subHeading',
        contents: [
            'ipmob.information_pg.content_1'
        ],
        email: 'ipmob.information_pg.email',
        help: 'ipmob.information_pg.help'
    };

    if (messageKey === 'NOT_ELIGIBLE') {
        infoMessages.header_1 = 'ipmob.ineligible_page.heading_4';
        setIneligibilityInfoMessages(infoMessages, ineligibilityStatus, brandName, siteName);
    } else if (messageKey === 'ERROR') {
        infoMessages.header_1 = 'ipmob.info.header.error';
        infoMessages.header_2 = 'ipmob.complete.dialog.heading';
        infoMessages.subHeading = '';
        infoMessages.contents = [
            'ipmob.info.dialog.list.error.content1',
            'ipmob.info.dialog.list.error.content2'
        ];
    }
    return infoMessages;
};

export default infoMessageMapper;
